import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Modal,
  Row,
  Select,
  Table,
  Tooltip,
  Tree,
  Image, Spin,
  message
} from "antd";
import React, { Component } from "react";
import CompanyAutocomplete from "./CompanyAutocomplete";
import { addMinutes, format, toDate } from "date-fns";
import dayjs from "dayjs";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import { observer } from "mobx-react";
import VideoMonitoringStore from "../store/VideoMonitoringStore";
import { CheckLg, PauseCircle, PlayCircle } from "react-bootstrap-icons";
import HLSPlayer from "./HlsPlayer";
import { DownloadOutlined } from "@ant-design/icons";
import FlvPlayer from "./Flvplayer";

const timeArray = [];

const startTime = new Date(2000, 0, 1, 0, 0); // 12:00 AM
const endTime = new Date(2000, 0, 1, 23, 30); // 11:45 P

for (let time = startTime; time <= endTime; time = addMinutes(time, 30)) {
  const formattedTime = format(time, "HH:mm:ss");
  var ob = {
    formattedTime: formattedTime,
    time: time,
  };
  timeArray.push(ob);
}

class VideoMonitoring extends Component {
  constructor(props, context) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      videoUrlArray: [],
      companyId: "",
      iframeSrcs: [],
      openVideoModal: false,
      selectedIframe: null,
      showPlaybackTable: false,
      showHowenPlaybackTable: false,
      showDownloadedVideoList: false,
      isPause: true,
      treeData: [],
      playbackVideoUrl: "",
      howenplaybackVideoUrl: "",
      showVideoWindow: false,
      showHowenVideoWindow: false,
      activeRow: null,
      channelId: 0,
      vehicleId: "",
      selectedData: [],
      showVideo: "",
      openCard: true,
      hiddenIframeKeys: [],
      mdvr: "",
      showDownloadbtn: false,
      fromDate: '',
      toDate: ''
    };
    this.videoMonitoringStore = new VideoMonitoringStore(this);

    this.columns = [
      {
        title: context.translate("_CHANNEL_"),
        dataIndex: this.state.mdvr === "H-Protocol" ? "channelNo" : "logicalChannelNumber",
        width: "12%",
        render: (text, record) => {
          return this.state.mdvr === "H-Protocol"
            ? record.channelNo
            : record.logicalChannelNumber ?? "";
        }

      },
      {
        title: context.translate("_STARTTIME_"),
        dataIndex: "startTime",
        width: "18%",
      },
      {
        title: context.translate("_END_TIME_"),
        dataIndex: "endTime",
        width: "18%",
      },
      ...(!this.state.showDownloadedVideoList
        ? [{
          title: context.translate("_PLAY_"),
          width: "10%",
          align: "center",
          render: (text, record) => (
            <div style={{ display: "flex", alignItems: "center" }}>
              {this.state.activeRow === record.startTime ? (
                <Tooltip title={"Pause"} color="green">
                  <PauseCircle
                    style={{ fontSize: "20px", cursor: "pointer" }}
                    onClick={() => {
                      this.setState({
                        activeRow: null,
                        showVideoWindow: false,
                        showHowenVideoWindow: false,
                        playbackVideoUrl: "",
                        howenplaybackVideoUrl: ""
                      });
                      if (this.state.mdvr === "JT1078") {
                        this.videoMonitoringStore.stopBsjVideo(record);

                      }
                    }}
                  />
                </Tooltip>
              ) : (
                <Tooltip title={"Play"} color="green">
                  {" "}
                  <PlayCircle
                    style={{ fontSize: "20px", cursor: "pointer" }}
                    onClick={() => {
                      if (this.state.mdvr === "JT1078") {
                        if (this.state.channelId === record.logicalChannelNumber) {
                          Modal.warning({
                            title: this.context.translate(
                              "_FLEET_DASHBORD_SHOWGEO_REMOVEALERT_"
                            ),
                            content: this.context.translate(
                              "Live streaming is currently active on this channel, so playback of recorded videos is unavailable."
                            ),
                          });
                        } else {
                          this.handlePlaybackVideo(record);
                          this.setState({
                            activeRow: record.startTime,
                            showVideoWindow: true,
                          });
                        }
                      } else {
                        this.handleHowenPlaybackVideo(record);
                        this.setState({
                          activeRow: record.startTime,
                          showHowenVideoWindow: true,
                        });
                      }

                    }}
                  />
                </Tooltip>
              )}
              {/* <Tooltip title={"Download"} color="green">
              <DownloadOutlined
                style={{
                  fontSize: "20px",
                  paddingInlineStart: "7px",
                  cursor: "pointer",
                }}
              />
            </Tooltip> */}
            </div>
          ),
        }]
        : []),
      ...(!this.state.showDownloadedVideoList
        ? [{
          title: context.translate("Download"),
          width: "15%",
          align: "center",
          render: (text, record) => (
            <>
              {Number(record.downloadStatus) === 1 ? (
                <Tooltip title={"Download"} color="black">
                  <img
                    src={require("../assets/images/download.png")}
                    alt="Download"
                    style={{ width: 23, height: 23, cursor: "pointer" }}
                    onClick={() => this.handleDownload(record)}
                  />
                </Tooltip>
              ) : Number(record.downloadStatus) === 2 ? (
                <Tooltip title={"Processing"} color="black">
                  <img
                    src={require("../assets/images/data-processing.png")}
                    alt="Processing"
                    style={{ width: 23, height: 23, cursor: "not-allowed" }}
                  />
                </Tooltip>
              ) : Number(record.downloadStatus) === 3 ? (
                <Tooltip title={"Downloaded"} color="black">
                  <img
                    src={require("../assets/images/success.png")}
                    alt="Downloaded"
                    style={{ width: 23, height: 23, cursor: "not-allowed" }}
                  />
                </Tooltip>
              ) : null}


            </>
          ),
        }]
        : []),
    ];
  }

  handlePlaybackVideo = async (record) => {
    const data = {
      channelId: record.logicalChannelNumber,
      vehicleId: this.state.vehicleId,
      full_imei: record.terminalPhone,
      streamType: record.streamType,
      memoryType: record.memoryType,
      beginTime: record.startTime,
      endTime: record.endTime,
    };
    const videoData = await this.videoMonitoringStore.getPlaybackVideoData(
      data
    );

    this.setState({ playbackVideoUrl: videoData.url });
  };

  handleHowenPlaybackVideo = async (record) => {
    const data = {
      companyId: this.state.companyId,
      channelId: record.channelNo,
      vehicleId: this.state.vehicleId,
      starttime: record.startTime,
      endTime: record.endTime,
    };
    const videoData = await this.videoMonitoringStore.gethowenPlaybackVideoData(
      data
    );

    this.setState({ howenplaybackVideoUrl: videoData.url });
  };
  onSubmit = async (obj) => {

    const filteredData = this.state.treeData?.filter(
      (item) => item.vehicleId === this.state.vehicleId
    );
    const MDVR = filteredData[0]?.MDVR;

    this.setState({ showVideo: MDVR, mdvr: MDVR });

    var fromDate = dayjs(obj.fromDate).format("YYYY-MM-DD");
    var toDate = dayjs(obj.toDate).format("YYYY-MM-DD");
    var fromTime = obj.fromTime;
    var toTime = dayjs().format("HH:mm:ss");

    var data = {
      channelId: obj.channelId,
      companyId: this.state.companyId,
      vehicleId: obj.vehicleId,
      starttime: fromDate + "  " + fromTime,
      endtime: toDate + "  " + toTime,
    };

    const playbackData = {
      companyId: this.state.companyId,
      vehicleId: obj.vehicleId,
      channelId: obj.channelId,
      starttime: fromDate + "  " + fromTime,
      endtime: toDate + "  " + toTime,
      imei: filteredData[0]?.full_imei,
    };

    this.setState({
      fromDate: fromDate + " " + fromTime,
      toDate: toDate + " " + toTime
    })

    if (MDVR === "JT1078") {
      await this.videoMonitoringStore.getPlaybackData(playbackData);

      await this.setState({ showPlaybackTable: true, showHowenPlaybackTable: false, showDownloadedVideoList: false });
    } else if (MDVR === "H-Protocol") {
      await this.videoMonitoringStore.fileRequestHowen(playbackData);
      await this.setState({ showHowenPlaybackTable: true, showPlaybackTable: false, showDownloadedVideoList: false });
      let attempt = 0;
      let dataReceived = false;

      while (attempt < 5 && !dataReceived) {
        const data = await this.videoMonitoringStore.gethowenPlaybackData(playbackData);

        if (data?.data?.data.length > 0) {
          dataReceived = true;
          break; // exit loop if data is received
        }

        attempt++;
        if (attempt < 5) {
          await new Promise(resolve => setTimeout(resolve, 5000)); // wait 5 sec between attempts
        }
      }

      if (!dataReceived) {
        Modal.warning({
          title: this.context.translate(
            "_FLEET_ALERT_"
          ),
          content: this.context.translate(
            'No data available'
          ),
        })
      }
      this.setState({ loadData: 1 })

    } else {
      const resp = await this.videoMonitoringStore.getPlayBackVideoNew(data);

      const videoUrls = [
        resp?.url1,
        resp?.url2,
        resp?.url3,
        resp?.url4,
        resp?.url5,
        resp?.url6,
        resp?.url7,
        resp?.url8,
      ];
      await this.setState({ videoUrlArray: videoUrls });

    }



  };

  handleChange = async (v) => {
    await this.setState({ companyId: v.value });
    const data = await this.videoMonitoringStore.getDevices({
      companyId: v.value,
    });

    await this.setState({
      treeData: data,
      showPlaybackTable: false,
      showHowenPlaybackTable: false,
      showDownloadedVideoList: false,
      iframeSrcs: [],
    });
    await this.setState({ update: 1 });
  };

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      const data = await this.videoMonitoringStore.getDevices({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.setState({ treeData: data, update: 1 });
    }
  }

  handleVideoChange = async (info) => {
    const childKey = info.node.vehicleId;

    const parent = await this.findParent(
      await this.videoMonitoringStore.deviceListArray,
      childKey
    );

    this.setState({ selectedData: parent });

    const host = parent?.cmsvssWebHost;
    const imei = parent?.full_imei;
    const UserName = parent?.cmsvssUserName;
    const Password = parent?.cmsvssPassword;
    const MDVR = parent?.MDVR;
    const channelId = info.node.channelId;
    const deviceId = parent?.deviceId;

    if (info.checked) {
      if (MDVR === "JT1078") {
        const data = {
          channelId: channelId,
          vehicleId: parent.vehicleId,
          full_imei: imei,
        };
        await this.videoMonitoringStore.bsjVideoMonitoring(data);

        // var url =
        //   "https://media.trackeazy.com/test/multimedia#" +
        //   imei +
        //   "-" +
        //   channelId;
        var url = "https://media.trackeazy.com/video/" + imei + "-" + channelId;

        this.setState({ channelId });
        this.setState((prevState) => ({
          iframeSrcs: [
            ...prevState.iframeSrcs,
            { key: info.node.key, src: url, title: info.node.title, mdvr: "JT1078" },
          ],
        }));
      } else if (MDVR === "CMS") {
        // Construct iframe source URL
        const iframeSrc = `${host}/808gps/open/player/video.html?lang=en&devIdno=${imei}&account=${UserName}&password=${Password}&channel=1&chns=${channelId - 1
          }`;

        this.setState((prevState) => ({
          iframeSrcs: [
            ...prevState.iframeSrcs,
            { key: info.node.key, src: iframeSrc, title: info.node.title },
          ],
        }));
      } else if (MDVR === "H-Protocol") {
        const mdvrdata = {
          vehicleId: parent.vehicleId,
          channelId: channelId,
          deviceId: deviceId,
          full_imei: imei,
        };

        await this.videoMonitoringStore.howenMDVRSocket(mdvrdata);

        // var url =
        //   "https://media.trackeazy.com/howen/test/multimedia#live_" +
        //   imei +
        //   "_0" +
        //   channelId +
        //   "_00";
        var url = "https://media.trackeazy.com/m3u8/live_" + imei + "_0" + channelId + "_00.m3u8";

        this.setState({ channelId });
        this.setState((prevState) => ({
          iframeSrcs: [
            ...prevState.iframeSrcs,
            { key: info.node.key, src: url, title: info.node.title, mdvr: "H-Protocol" },
          ],
        }));
      } else {
        const port = parent?.cmsvssWebPort;
        const token = parent?.token;

        let iframeSrc = "";

        if (port != null) {
          iframeSrc = `${host}:${port}/vss/apiPage/RealVideo.html?token=${token}&deviceId=${imei}&chs=${channelId}&stream=0&wnum=0&buffer=0&panel=1`;
        } else {
          iframeSrc = `${host}/vss/apiPage/RealVideo.html?token=${token}&deviceId=${imei}&chs=${channelId}&stream=0&wnum=0&buffer=0&panel=1`;
        }
        console.log(iframeSrc);
        this.setState((prevState) => ({
          iframeSrcs: [
            ...prevState.iframeSrcs,
            { key: info.node.key, src: iframeSrc, title: info.node.title },
          ],
        }));
      }
    } else {
      this.setState((prevState) => ({
        iframeSrcs: prevState.iframeSrcs.filter(
          (iframe) => iframe.key !== info.node.key
        ),
      }));
    }
  };

  renderTreeNodes = (data) => {
    return data?.map((item) => {
      // const isParent = item?.children && item.children?.length > 0;

      return {
        ...item,
        title: (
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Image
              width={35}
              src={require("../assets/images/detailtracking/" + item.listImage)}
              style={{ marginInlineEnd: "6px" }}
            />
            {item.text || item.title || ""}
          </span>
        ),
      };
    });
  };

  openModal = (iframe) => {
    this.setState((prevState) => ({
      openVideoModal: true,
      selectedIframe: iframe,
      hiddenIframeKeys: [...prevState.hiddenIframeKeys, iframe.key],
    }));
  };

  closeModal = () => {
    this.setState((prevState) => ({
      openVideoModal: false,
      hiddenIframeKeys: prevState.hiddenIframeKeys.filter(
        (key) => key !== prevState.selectedIframe?.key
      ),
      selectedIframe: null,
    }));
  };

  findParent = async (tree, key) => {
    for (const node of tree) {
      if (node.vehicleId === key) {
        return node;
      }
      if (node.children) {
        const found = await this.findParent(node.children, key);
        if (found) return node;
      }
    }
    return null;


  };
  async handleDownload(record) {
    console.log(record, "record");
    const data = {
      companyId: this.state.companyId,
      channelId: record.channelNo,
      vehicleId: this.state.vehicleId,
      starttime: record.startTime,
      endTime: record.endTime,
      isDownload: 1
    };
    // const videoData=false
    const videoData = await this.videoMonitoringStore.gethowenPlaybackVideoData(
      data
    );

    if (videoData) {
      data.url = videoData.url
      data.fileName = videoData.fileName
      data.sessionNo = videoData.sessionNo
      data.filesize = record.filesize
      const res = await this.videoMonitoringStore.downloadHowenVideo(data);
      if (res.success) {
        message.success(res.message);
        const data1 = {
          companyId: this.state.companyId,
          channelId: record.channelNo,
          vehicleId: this.state.vehicleId,
          starttime: this.state.fromDate,
          endTime: this.state.toDate,
          isDownload: 1
        };

        const response = await this.videoMonitoringStore.gethowenPlaybackData(data1);
        this.setState({ loadData: 1 })

      } else {
        message.error("Something went wrong");
      }

    }

  };

  handleDownloadVideoList = async () => {

    this.setState({ showDownloadedVideoList: false, showVideoWindow: false, showHowenVideoWindow: false, activeRow: null });
    //form values will be here  
    const values = this.formRef.current.getFieldsValue();
    const channelId = values.channelId;
    // const fromDate = this.state.fromDate;
    // const toDate = this.state.toDate;

    const fromDate = dayjs(values.fromDate).format("YYYY-MM-DD");
    const toDate = dayjs(values.toDate).format("YYYY-MM-DD");
    const fromTime = values.fromTime;
    const toTime = dayjs(values.toTime).format("HH:mm:ss");


    const data = {
      vehicleId: this.state.vehicleId,
      channelId: channelId,
      fromDate: fromDate + " " + fromTime,
      toDate: toDate + " " + toTime,
    };
    const res = await this.videoMonitoringStore.fetchDownloadVideoList(data);
    if (res) {
      const filteredData = this.state.treeData?.filter(
        (item) => item.vehicleId === this.state.vehicleId
      );
      const MDVR = filteredData[0]?.MDVR;

      this.setState({ mdvr: MDVR });

      await this.setState({ loadData: 1, showDownloadedVideoList: true, showPlaybackTable: false, showHowenPlaybackTable: false });

    } else {
      message.error("Something went wrong");
    }
  }
  getColumns = () => {
    return [
      {
        title: this.context.translate("_CHANNEL_"),
        dataIndex: this.state.mdvr === "H-Protocol" ? "channelNo" : "logicalChannelNumber",
        width: "12%",
        render: (text, record) =>
          this.state.mdvr === "H-Protocol"
            ? record.channelNo
            : record.logicalChannelNumber ?? "",
      },
      {
        title: this.context.translate("_STARTTIME_"),
        dataIndex: "startTime",
        width: "18%",
      },
      {
        title: this.context.translate("_END_TIME_"),
        dataIndex: "endTime",
        width: "18%",
      },
      ...(!this.state.showDownloadedVideoList
        ? [
          {
            title: this.context.translate("_PLAY_"),
            width: "10%",
            align: "center",
            render: (text, record) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                {this.state.activeRow === record.startTime ? (
                  <Tooltip title={"Pause"} color="green">
                    <PauseCircle
                      style={{ fontSize: "20px", cursor: "pointer" }}
                      onClick={() => {
                        this.setState({
                          activeRow: null,
                          showVideoWindow: false,
                          showHowenVideoWindow: false,
                          playbackVideoUrl: "",
                          howenplaybackVideoUrl: "",
                        });
                        if (this.state.mdvr === "JT1078") {
                          this.videoMonitoringStore.stopBsjVideo(record);
                        }
                      }}
                    />
                  </Tooltip>
                ) : (
                  <Tooltip title={"Play"} color="green">
                    <PlayCircle
                      style={{ fontSize: "20px", cursor: "pointer" }}
                      onClick={() => {
                        if (this.state.mdvr === "JT1078") {
                          if (this.state.channelId === record.logicalChannelNumber) {
                            Modal.warning({
                              title: this.context.translate(
                                "_FLEET_DASHBORD_SHOWGEO_REMOVEALERT_"
                              ),
                              content: this.context.translate(
                                "Live streaming is currently active on this channel, so playback of recorded videos is unavailable."
                              ),
                            });
                          } else {
                            this.handlePlaybackVideo(record);
                            this.setState({
                              activeRow: record.startTime,
                              showVideoWindow: true,
                            });
                          }
                        } else {
                          this.handleHowenPlaybackVideo(record);
                          this.setState({
                            activeRow: record.startTime,
                            showHowenVideoWindow: true,
                          });
                        }
                      }}
                    />
                  </Tooltip>
                )}
              </div>
            ),
          },
        ]
        : [

          {
            title: this.context.translate("_PLAY_"),
            width: "10%",
            align: "center",
            render: (text, record) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                {this.state.activeRow === record.startTime ? (
                  <Tooltip title={"Pause"} color="green">
                    <PauseCircle
                      style={{ fontSize: "20px", cursor: "pointer" }}
                      onClick={() => {
                        this.setState({
                          activeRow: null,
                          showVideoWindow: false,
                          showHowenVideoWindow: false,
                          playbackVideoUrl: "",
                          howenplaybackVideoUrl: "",
                        });

                      }}
                    />
                  </Tooltip>
                ) : (
                  <Tooltip title={"Play"} color="green">
                    <PlayCircle
                      style={{ fontSize: "20px", cursor: "pointer" }}
                      onClick={() => {
                        console.log("errree")
                        if (this.state.activeRow === record.startTime) {
                          // same row clicked again → pause
                          this.setState({
                            activeRow: null,
                            showHowenVideoWindow: false,
                            howenplaybackVideoUrl: ""
                          });
                        } else {
                          // new row clicked → stop old, play new
                          this.setState({
                            activeRow: record.startTime,
                            showHowenVideoWindow: true,
                            howenplaybackVideoUrl: record.url
                          });
                        }
                      }}

                    />
                  </Tooltip>
                )}
              </div>
            )
          }
        ]),
      ...(!this.state.showDownloadedVideoList
        ? [
          {
            title: this.context.translate("Download"),
            width: "15%",
            align: "center",
            render: (text, record) => (
              <Tooltip title={"Download"} color="black">
                {record.isFileAvailable ? (
                  <img
                    src={require("../assets/images/download.png")}
                    alt="Download"
                    style={{ width: 23, height: 23, cursor: "pointer" }}
                    onClick={() => this.handleDownload(record)}
                  />
                ) : (
                  <img
                    src={require("../assets/images/processing-time.png")}
                    alt="Processing"
                    style={{ width: 23, height: 23, cursor: "not-allowed" }}
                  />
                )}

              </Tooltip>
            ),
          },
        ]
        : []),
    ];
  };

  render() {
    return (
      <div>
        <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_VIDEO_MONITORING_")}
              </div>
            </Col>
          </Row>
        </div>

        <Row className="video-monitoring">
          <Col span={4} className="live-video-streaming-block">
            <div className="heading">
              {this.context.translate("_LIVE_VIDEO_STREAMING_")}
            </div>
            <CompanyAutocomplete
              onChange={(v) => this.handleChange(v)}
              style={{ padding: "10px", width: "100%" }}
            />

            <Tree
              checkable
              showIcon
              showLine={true}
              onCheck={(e, info) => {
                this.handleVideoChange(info);
                this.setState({ playbackVideoUrl: "", showVideoWindow: false, howenplaybackVideoUrl: "", showHowenVideoWindow: false });
              }}
              treeData={this.renderTreeNodes(
                this.videoMonitoringStore.deviceListArray
              )}
            />
          </Col>

          <Col span={16} style={{ height: "90vh", overflow: "auto" }}>
            <>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  // overflow: "auto",
                  // height: "80vh",
                }}
              >
                {this.state.showVideo !== "JT1078" &&
                  this.state.selectedData?.MDVR !== "JT1078" &&
                  this.state.videoUrlArray &&
                  this.state.videoUrlArray.map((url, index) => (
                    <iframe
                      key={index}
                      style={{ padding: "20px", height: "262px" }}
                      width="50%"
                      height="50%"
                      src={url}
                      title={`Video ${index + 1}`}
                      allowFullScreen
                    ></iframe>
                  ))}
              </div>
            </>
            <>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "20px",
                  margin: "12px",
                }}
              >
                {this.state.openCard &&
                  this.state.iframeSrcs
                    .filter(
                      (iframe) =>
                        !this.state.hiddenIframeKeys.includes(iframe.key)
                    )
                    .map((iframe) => (
                      <Card
                        key={iframe.key}
                        title={
                          <div
                            style={{
                              fontSize: 17,
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="videoCardTitle"
                          >
                            {iframe.title}
                            <i
                              className="bi bi-arrows-fullscreen"
                              style={{
                                border: "none",
                                fontSize: "17px",
                                cursor: "pointer",
                              }}
                              onClick={() => this.openModal(iframe)}
                            ></i>
                          </div>
                        }
                        style={{ width: 300 }}
                      >
                        {
                          iframe.mdvr === "H-Protocol" ? (
                            <HLSPlayer src={iframe.src} />
                          ) : iframe.mdvr === "JT1078" ? (
                            <FlvPlayer url={iframe.src} />
                          ) : (
                            <iframe
                              key={iframe.key}
                              src={iframe.src}
                              width="100%"
                              height="200px"
                              frameBorder="0"
                              scrolling="no"
                              allow="fullscreen"
                              title={`Video Player ${iframe.key}`}
                            />
                          )
                        }

                      </Card>
                    ))}
              </div>
            </>
            <Row span={24}>
              <Col span={12}>
                {this.state.showPlaybackTable && (
                  <>
                    <div
                      style={{
                        paddingInlineStart: "20px",
                        // backgroundColor: "#e0e0e0",
                      }}
                    >
                      Playback Video Data
                    </div>
                    <div style={{ paddingInlineStart: "20px" }}>
                      <Table
                        dataSource={this.videoMonitoringStore.playbackData}
                        columns={this.columns}
                        pagination={false}
                        bordered
                        small
                        scroll={{
                          y: 550,
                        }}
                      />
                    </div>
                  </>
                )}
                {this.state.showHowenPlaybackTable && (
                  <>
                    <div
                      style={{
                        paddingInlineStart: "20px",
                        // backgroundColor: "#e0e0e0",
                      }}
                    >
                      Playback Video Data
                    </div>{console.log(this.videoMonitoringStore.playbackhowenData)}
                    <div style={{ paddingInlineStart: "20px" }}>
                      <Table
                        dataSource={this.videoMonitoringStore.playbackhowenData}
                        columns={this.columns}
                        pagination={false}
                        bordered
                        small
                        scroll={{
                          y: 550,
                        }}
                      />
                    </div>
                  </>
                )}
                {console.log("downloadedlistData", this.videoMonitoringStore.downloadedlistData)}
                {
                  this.state.showDownloadedVideoList &&
                  <>
                    <div
                      style={{
                        paddingInlineStart: "20px",
                        // backgroundColor: "#e0e0e0",
                      }}
                    >
                      Downloaded Video Data
                    </div>{console.log(this.videoMonitoringStore.downloadedlistData)}
                    <div style={{ paddingInlineStart: "20px" }}>
                      <Table
                        dataSource={this.videoMonitoringStore.downloadedlistData.slice()}
                        columns={this.getColumns()}
                        pagination={false}
                        bordered
                        small
                        scroll={{
                          y: 550,
                        }}
                      />
                    </div>
                  </>
                }
              </Col>
              <Col span={1} />
              <Col span={11}>
                {this.state.showVideoWindow && this.state.playbackVideoUrl && (
                  <Card style={{ width: 400 }}>
                    <iframe
                      key={1}
                      src={this.state.playbackVideoUrl}
                      style={{ width: "100%", aspectRatio: "16/9" }}
                      // padding="10px"
                      scrolling="no"
                      allow="fullscreen"
                      title="Playback Video"
                      aria-label="Video Player"
                    />
                  </Card>
                )}
                {this.state.showHowenVideoWindow && this.state.howenplaybackVideoUrl && (
                  <Card style={{ width: 400 }}>
                    <iframe
                      src={this.state.howenplaybackVideoUrl}
                      key={this.state.howenplaybackVideoUrl}
                      style={{ width: "100%", aspectRatio: "16/9" }}
                      // padding="10px"
                      scrolling="no"
                      allow="fullscreen"
                      title="Playback Video"
                      aria-label="Video Player"
                    />
                  </Card>
                )}
              </Col>
            </Row>
          </Col>

          <Col span={4} className="playback-options-block">
            <div className="heading">
              {this.context.translate("_PLAY_BACK_OPTION_")}
            </div>

            <Form
              ref={this.formRef}
              layout="vertical"
              name="nest-messages"
              onFinish={this.onSubmit}
              style={{ padding: "15px" }}
              className="formClass"
            >
              <Form.Item
                name="vehicleId"
                label={this.context.translate("_VEHICLES_")}
                rules={[{ required: true }]}
              >
                <Select
                  onSelect={(value) => {
                    console.log(this.state.treeData);
                    const filteredData = this.state.treeData?.filter(
                      (item) => item.vehicleId === value
                    );
                    const MDVR = filteredData[0]?.MDVR;
                    console.log(MDVR)
                    MDVR === "H-Protocol" ? this.setState({ showDownloadbtn: true }) : this.setState({ showDownloadbtn: false });
                    this.setState({ vehicleId: value });
                  }}
                  options={this.videoMonitoringStore.deviceListArray}
                  fieldNames={{ value: "vehicleId", label: "text" }}
                  showSearch
                  filterOption={(input, option) => {
                    console.log(input)
                    if (!option?.text) return false;

                    const label = option.text
                      .toString()
                      .toLowerCase()
                      .replace(/\s+/g, "");

                    const search = input
                      .toLowerCase()
                      .replace(/\s+/g, "");

                    return label.includes(search);
                  }}
                ></Select>
              </Form.Item>
              <Form.Item
                name="channelId"
                label={this.context.translate("_CHANNEL_")}
                rules={[{ required: true }]}
              >
                <Select
                  style={{ height: "44px !important" }}
                  placeholder={this.context.translate("_SELECT_CHANNEL_")}
                  options={[
                    { label: "Channel1", value: 1 },
                    { label: "Channel2", value: 2 },
                    { label: "Channel3", value: 3 },
                    { label: "Channel4", value: 4 },
                    { label: "Channel5", value: 5 },
                    { label: "Channel6", value: 6 },
                    { label: "Channel7", value: 7 },
                    { label: "Channel8", value: 8 },
                  ]}
                  className="search-field"
                  mode="multiple"
                  maxTagCount={"responsive"}
                />
              </Form.Item>

              <Form.Item
                name="fromDate"
                className="blur-input"
                label={this.context.translate("_FROM_DATE_")}
                initialValue={dayjs()}
              >
                <DatePicker style={{ width: "100%" }} format={"YYYY-MM-DD"} />
              </Form.Item>

              <Form.Item
                name="fromTime"
                label={this.context.translate(
                  "_FLEET_RULESELECTORDETAIL_RULE4_FROMTIME_"
                )}
                className="blur-input"
                rules={[{ required: true }]}
                initialValue={"00:00:00"}
              >
                <Select
                  onChange={(val) =>
                    this.formRef.current.setFieldsValue({ fromTime: val })
                  }
                >
                  {timeArray.map((data) => {
                    return (
                      <Select.Option
                        key={data.formattedTime}
                        value={data.formattedTime}
                      >
                        {format(data.time, "h:mm aa")}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>

              <Form.Item
                name="toDate"
                className="blur-input"
                label={this.context.translate("_TO_DATE_")}
              >
                <DatePicker
                  defaultValue={dayjs()}
                  style={{ width: "100%" }}
                  format={"YYYY-MM-DD"}
                />
              </Form.Item>

              <Form.Item
                name="toTime"
                label={this.context.translate(
                  "_FLEET_RULESELECTORDETAIL_RULE4_TOTIME_"
                )}
                className="blur-input"
                rules={[{ required: true }]}
                initialValue={dayjs().format("hh:mm A ")}
              >
                <Select
                  onChange={(val) =>
                    this.formRef.current.setFieldsValue({ toTime: val })
                  }
                >
                  {timeArray.map((data) => {
                    return (
                      <Select.Option
                        key={data.formattedTime}
                        value={data.formattedTime}
                      >
                        {format(data.time, "h:mm aa")}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>

              <Form.Item label=" ">
                <Button
                  htmlType="submit"
                  type="primary"
                  style={{ width: "100%" }}
                >
                  {this.context.translate("_FETCH_PLAYBACK_VIDEO_BUTTON_")}
                </Button>
              </Form.Item>
              {this.state.showDownloadbtn && <Form.Item label=" ">
                <Button
                  // htmlType="submit"
                  type="primary"
                  style={{ width: "100%" }}
                  onClick={this.handleDownloadVideoList}
                >
                  {this.context.translate("_DOWNLOAD_VIDEO_LIST_BUTTON_")}
                </Button>
              </Form.Item>}
            </Form>
          </Col>
        </Row>

        <Modal
          open={this.state.openVideoModal}
          onCancel={this.closeModal}
          footer={null}
          width={800}
          title={this.state.selectedIframe?.title}
        >
          {this.state.selectedIframe && (
            // (this.state.selectedIframe.mdvr == "H-Protocol" || this.state.selectedIframe.mdvr == "JT1078") ?
            // <HLSPlayer src={this.state.selectedIframe.src} />
            // <FlvPlayer url={this.state.selectedIframe.src}  />
            this.state.selectedIframe.mdvr === "H-Protocol" ? (
              <HLSPlayer src={this.state.selectedIframe.src} />
            ) : this.state.selectedIframe.mdvr === "JT1078" ? (
              <FlvPlayer url={this.state.selectedIframe.src} />
            )
              :
              <iframe
                key={this.state.selectedIframe.key}
                src={this.state.selectedIframe.src}
                width="100%"
                height="200px"
                frameBorder="0"
                scrolling="no"
                allow="fullscreen"
                title={`Video Player ${this.state.selectedIframe.key}`}
              />
          )}
        </Modal>
      </div>
    );
  }
}
VideoMonitoring.contextType = StoreContext;
export default observer(withRouter(VideoMonitoring));
